// frontend/src/components/FinanceReport/Accounting/allocations/OrderCodeInput.jsx
import React, { useEffect, useState } from "react";
import { getOrderCode } from "./helpers";

export default function OrderCodeInput({
  id,
  orders,
  value,
  onChange,
  className = "w-full rounded border px-1 py-0.5 text-xs",
  placeholder,
}) {
  const [draft, setDraft] = useState(value || "");

  useEffect(() => {
    setDraft(value || "");
  }, [value]);

  const handleFocus = () => {
    const lower = draft.trim().toLowerCase();
    const matches = orders.some(
      (o) => getOrderCode(o).trim().toLowerCase() === lower
    );
    if (matches) setDraft("");
  };

  const handleBlur = () => {
    if (!draft.trim() && value) setDraft(value);
  };

  const handleChange = (e) => {
    const v = e.target.value;
    setDraft(v);
    onChange(v);
  };

  return (
    <>
      <input
        list={id}
        className={className}
        placeholder={placeholder}
        value={draft}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        autoComplete="off"
      />
      <datalist id={id}>
        {orders.map((o) => (
          <option
            key={o.id}
            value={getOrderCode(o)}
            label={[getOrderCode(o), o._clientName || ""]
              .filter(Boolean)
              .join(" — ")}
          />
        ))}
      </datalist>
    </>
  );
}